<div id="focus-wrapper" tabindex="-1">
  @for (question of questions; track question) {
    @if (question.id === currentQuestion.id) {
      <app-question id="current-question" [question]="question"
        [preFilledAnswer]="currentAnswer" [class]="question.id">
        <div class="meta mt-0" id="max-questions-left">
          <span>{{maximumQuestionsLeftText}}</span>
        </div>
        <div class="mb-3">
          <ngf-progress-bar min="0" max="100" [value]="maxQuestionsLeftPercentage"
            [srText]="maximumQuestionsLeftScreenReaderText">
          </ngf-progress-bar>
        </div>
      </app-question>
    }
  }
</div>